import styled from '@emotion/styled';

export const StyledReportWrap = styled.div`
  margin-top: 15px;
`;

export const StyledSMWIArea = styled.div`
  display: flex;
  min-width: 1000px;
  align-items: center;
  margin-bottom: 10px;
  padding: 15px 13px;
  background: #fff;
  & > strong {
    position: relative;
    display: block;
    width: 179px;
    height: 24px;
    margin-right: 13px;
    text-align: center;
    font-size: 16px;
    line-height: 23px;
    color: #333;
  }
`;

export const StyledSMWIFlex = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding-left: 36px;
  color: #555;

  & .send-off,
  .send-on {
    font-weight: 400;
    font-size: 14px;
  }

  &:before {
    content: '';
    top: 0;
    bottom: 0;
    left: 0;
    display: block;
    width: 1px;
    position: absolute;
    background: #e0e0e0;
  }

  & > div {
    display: flex;
    align-items: center;
    margin-left: 40px;
  }
`;

export const StyledNotice = styled.div`
  margin-top: 12px;
  font-size: 12px;
  color: #fa8282;
  & p {
    margin: 0;
  }
`;

export const StyledSwButtonSection = styled.section`
  display: flex;
  justify-content: flex-end;
  margin-top: 53px;
  & button {
    margin-top: 0;
  }
`;
